import type { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

interface PanelBodyProps extends PropsWithChildren {
  className?: string
}

export function PanelBody({ children, className }: PanelBodyProps) {
  return <div className={cn('bg-muted', className)}>{children}</div>
}
